{
    "agenda": "Agenda",
    "allDay": "All day",
    "date": "Date",
    "day": "Day",
    "event": "Session",
    "month": "Month",
    "next": "Next",
    "noEventsInRange": "No sessions in range",
    "previous": "Previous",
    "time": "Time",
    "today": "Today",
    "tomorrow": "Tomorrow",
    "week": "Week",
    "workWeek": "Work Week",
    "yesterday": "Yesterday",
    "more": "more",

    "currentMonth": "Current month",
    "from": "From",
    "lastFifteenDays": "Last 15 days",
    "lastSevenDays": "Last seven days",
    "lastThirtyDays": "Last 30 days",
    "lastWeek": "Last week",
    "nextMonth": "Next month",
    "reset": "Reset",
    "thisWeek": "This week",
    "to": "To"
}
